import {CLIENT_CODES_CO_UK} from './siteIds'

const config = {
  clientId: CLIENT_CODES_CO_UK,
  clientUrl: 'https://www.Codes.co.uk/',
  privacyPolicyUrl: 'https://www.codes.co.uk/privacy-policy',
  termsUrl: 'https://www.codes.co.uk/privacy-policy',
  appName: 'Codes.co.uk',
  siteName: 'Codes.co.uk',
  discountText: 'Voucher',
  discountsText: 'Vouchers',
  helpEmail: 'mailto:adcenter@surfmyads.com',
  price: 19.99,
  currency: 'GBP',
  currencySymbol: '£',
  primaryColor: 'red',
  outlineFocusColor: 'focus:outline-blue-700',
  infoBg: 'bg-yellow-400',
  bgColor: 'bg-blue-700',
  hoverColor: 'bg-blue-700',
  focusVisibleColor: `focus-visible:outline-blue-700`,
  textColor: `text-blue-700`,
  hoverTextColor: `hover:text-blue-600`,
  brands: [
    {
      name: 'boxt',
      logo: '/popular-brands/boxt-discount-codes.png',
    },
    {name: 'chicco', logo: '/popular-brands/chicco-discount-codes.png'},
    {name: 'converse', logo: '/popular-brands/converse-discount-codes.png'},
    {
      name: 'cotton-traders',
      logo: '/popular-brands/cotton-traders-discount-codes.png',
    },
    {name: 'gousto', logo: '/popular-brands/gousto-discount-codes.png'},
    {
      name: 'lastminute-com',
      logo: '/popular-brands/lastminute-com-discount-codes.png',
    },
    {name: 'nike', logo: '/popular-brands/nike-discount-codes.png'},
    {name: 'samsung', logo: '/popular-brands/samsung-discount-codes.png'},
    {
      name: 'harvey-nichols',
      logo: '/popular-brands/harvey-nichols-discount-codes.png',
    },
    {name: 'superdrug', logo: '/popular-brands/superdrug-discount-codes.png'},
  ],
}
export default config
